export class Tag {
    tagId:string;
    title:string;
    tagtype:string;
    creator?:string;
    created?:string;
    organizationId:string;
    organizationname:string;
}